//проверка на возможность отображения функционала в рамках договора
export function verifyAccess(pageRoles, selectedDog){
    if (!selectedDog) return false
    //return (pageRoles.filter(role => dogovorRoles.includes(role)).length > 0)
    const arr = pageRoles.filter(role => selectedDog.roles.indexOf(role) !== -1)
    return (arr.length > 0)
}